import L from 'leaflet';
import 'leaflet-draw';

/**
 * Removes all the listeners in the leaflet map for component unmount.
 *
 * @param {object} leafletMap - The leaflet map.
 */
const unloadMap = leafletMap => {
  leafletMap.off('moveend');
  leafletMap.off('click');
  leafletMap.off(L.Draw.Event.CREATED);
  leafletMap.off(L.Draw.Event.EDITED);
  leafletMap.off(L.Draw.Event.DELETED);
  leafletMap.off(L.Draw.Event.EDITVERTEX);
  leafletMap.off('mousemove');
};

export default unloadMap;
